





































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  form1: any;
  form2: any;

  categories: any[] = [];

  category: any[] = [];
  category_limit = 0;
  limit = 0;
  quota = 0;

  spinLoading1 = false;
  spinContent1 = "请稍后";

  treeData: any[] = [];

  beforeCreate() {
    this.form1 = this.$form.createForm(this, {});
    this.form2 = this.$form.createForm(this, {});
  }

  handleSubmit1() {
    this.form1.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        console.log(fieldValues);
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要设置类目吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("oplatformapps/addcategory", {
              appid: this.appid,
              first: fieldValues.first,
              second: fieldValues.second
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.loadCategory();
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleSubmit2() {
    this.form2.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要删除类目吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("oplatformapps/deletecategory", {
              appid: this.appid,
              first: fieldValues.first,
              second: fieldValues.second
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.loadCategory();
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }
  mounted() {
    this.loadCategories();

    this.loadCategory();
  }

  async loadCategories() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/getcategoriesbytype", {
      appid: this.appid
    });

    this.spinLoading = false;
    // console.log(res);
    if (res && res.Data) {
      this.categories = res.Data.categories;

      // id=0的children
      const firstChildrenIds: [] = this.categories[0].children;

      const firstchildren = this.findChildren(firstChildrenIds);

      for (const obj of firstchildren) {
        const childrenIds: [] = obj.children;

        const children = this.findChildren(childrenIds);

        let arr = [];

        for (const obj1 of children) {
          arr.push({
            parent_id: obj.id,
            title: `${obj1.name}(id：${obj1.id},需审核：${obj1.sensitive_type ? "是" : "否"})`,
            key: obj1.id
          });
        }

        this.treeData.push({
          parent_id: 0,
          title: `${obj.name}(id：${obj.id},需审核：${obj.sensitive_type ? "是" : "否"})`,
          key: obj.id,
          children: arr
        });
      }
    }
  }

  async loadCategory() {
    this.spinLoading1 = true;
    const res = await this.$store.dispatch("oplatformapps/getcategory", {
      appid: this.appid
    });

    this.spinLoading1 = false;
    if (res && res.Data) {
      this.limit = res.Data.limit;
      this.quota = res.Data.quota;
      this.category_limit = res.Data.category_limit;
      this.category = res.Data.categories;
    }
  }

  findChildren(children: number[]) {
    let arr = [];
    for (const id of children) {
      const obj = _.find(this.categories, o => {
        return o.id == id;
      });
      if (obj) {
        arr.push(obj);
      }
    }
    return arr;
  }
}
